import React from 'react';
import loadable from '@loadable/component';
import isNewConsumerApp from 'commons/isNewConsumerApp';

const JoybirdMasonryComponentNew = loadable(() =>
  import('./JoybirdMasonryComponentNew')
);
const JoybirdMasonryComponentLegacy = loadable(() =>
  import('./JoybirdMasonryComponentLegacy')
);

const JoybirdMasonry = ({ photoCardsList, isSidebarOpen = false }) => {
  if (isNewConsumerApp) {
    return (
      <JoybirdMasonryComponentNew
        photoCardsList={photoCardsList}
        isSidebarOpen={isSidebarOpen}
      />
    );
  }
  return <JoybirdMasonryComponentLegacy photoCardsList={photoCardsList} />;
};

export default JoybirdMasonry;
